/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import {
  type UseMutationResult,
  type UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

import { type BillingSettings, billingSettingsApi } from '../api/billing-settings.js';

const BILLING_SETTINGS_KEY = ['finance', 'settings'] as const;

export function useBillingSettings(): UseQueryResult<BillingSettings> {
  return useQuery({
    queryKey: BILLING_SETTINGS_KEY,
    queryFn: () => billingSettingsApi.get(),
  });
}

export function useUpdateBillingSettings(): UseMutationResult<
  BillingSettings,
  Error,
  BillingSettings
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: BillingSettings) => billingSettingsApi.update(input),
    onSuccess: (data) => {
      qc.setQueryData(BILLING_SETTINGS_KEY, data);
    },
  });
}
